import "./TrackingException.scss";
import Badge from "components/v2/Badge/Badge";
import { ReactComponent as InfoIcon } from "assets/images/iconsV2/info-circle-sm.svg";

export type TrackingExceptionProps = {
  exceptionLabel: string;
  labelAdditionalInfo?: string;
  exceptionDetails?: Array<{ title?: string; description?: string }>;
};

const TrackingException = function (props: TrackingExceptionProps) {
  const { exceptionLabel, labelAdditionalInfo, exceptionDetails } = props;
  const hasExceptionDetails = exceptionDetails && exceptionDetails.length > 0;

  return (
    <div className="d-flex mt-xxs tracking-exception">
      <Badge
        label={
          <>
            {exceptionLabel}
            {labelAdditionalInfo && (
              <>
                : <span className="font-regular">{labelAdditionalInfo}</span>
              </>
            )}
          </>
        }
        size="sm"
        type="status-badge"
        color="warning"
        variant={hasExceptionDetails ? "icon-trailing" : "text-only"}
        icon={
          hasExceptionDetails ? (
            <div className="position-relative">
              <div className="tracking-exception__overlay">
                {exceptionDetails?.map((exception, index) => (
                  <div key={index} className="text-primary text-xs d-flex align-items-center font-regular">
                    {exception.title && <span className="text-tertiary mr-xs">{exception.title}</span>}
                    {exception.title && exception.description && ": "}
                    {exception.description}
                  </div>
                ))}
              </div>
              <InfoIcon />
            </div>
          ) : null
        }
      />
    </div>
  );
};

export default TrackingException;

TrackingException.defaultProps = {
  exceptionDetails: undefined,
  labelAdditionalInfo: undefined,
};
